import React from 'react';
import PropTypes from 'prop-types';
import css from './CookiesAlert.scss';
import { connect } from 'react-redux';
import { Link } from 'panamera-react-ui';
import { FormattedMessage as Translation } from 'react-intl';
import cookieManagerHelper from 'Helpers/cookies';
import * as objectsHelper from 'Helpers/objects';
import * as configHelper from 'Helpers/config';
import { configSelector } from 'Selectors/config';

export class CookiesAlert extends React.Component {
    static propTypes = {
        config: PropTypes.object
    };

    static defaultProps = {
        config: {}
    };

    constructor(props) {
        super(props);

        this.state = {
            close: false
        };
    }

    clickAccept = () => {
        cookieManagerHelper.createCookie('cokal', 1);
        this.setState({
            close: true
        });
    }

    render() {
        const countryConfig = configHelper.getCountryConfig(this.props.config);

        if (objectsHelper.isEmpty(countryConfig) || !countryConfig.privacy_links || !countryConfig.privacy_links.cookies_url) {
            return null;
        }

        return (
            <div
                className={ `${ css.cookiesAlert } ${ this.state.close ? css.close : '' }` }
            >
                <p
                    className={ css.text }
                >
                    <Translation id="cookies_banner_copy" />
                </p>
                <div
                    className={ css.ctas }
                >
                    <Link
                        className={ css.link }
                        to={ countryConfig.privacy_links.cookies_url }
                    >
                        <Translation id="cookies_banner_more_button" />
                    </Link>
                    <span
                        className={ css.link }
                        onClick={ this.clickAccept }
                        data-aut-id="clickAccept"
                    >
                        <Translation id="cookies_banner_accept_button" />
                    </span>
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        config: configSelector(state)
    };
};

export default connect(mapStateToProps)(CookiesAlert);
